import React, { useState, useContext, useEffect } from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { Container, Button, Form, Nav } from "react-bootstrap";
import "./login.scss";
import { useFormik } from "formik";
import { login } from "../../RestApi/RestApi";
import { AuthContext } from "../../Context/AuthContext";
import { DashboardLoader } from "../../Components/Common/Loader/SkeletonLoader";

import Session from "../../Utils/Session";
import InLineErrorMessage from "../../Components/Common/AlertMessage/InLineErrorMessage";
import RoundLoaderWithOverlay from "../../Components/Common/Loader/RoundLoader";

import IdleTimer from "../../Utils/IdleTimer";
import { useTranslation } from "react-i18next";
import { getValidationSchema } from "../../Utils/formikValidator";
import {
  WEBSITE_URL,
  getLocaleFromCookie,
  publicRoutesName,
  // setTeamId,
} from "../../Utils/utils";
// import { AppLogo } from "../../Components/Common/SvgFiles/AppLogo";
import Cookies from "js-cookie";

const fieldsToBeValidate = [
  {
    type: "email",
    name: "email",
    isRequired: true,
    maxLength: 255,
    minLength: 5,
    isNullable: false,
  },
  {
    type: "password",
    name: "password",
    isRequired: true,
    maxLength: null,
    minLength: null,
    isNullable: false,
  },
];
/** NEW LOG IN PAGE **/
const SignIn = (props) => {
  const location = useLocation();
  const { pathname } = useLocation();
  const { t: locale } = useTranslation();
  const { userData, setUser, logOut } = useContext(AuthContext);
  const [showPassword, setShowPassword] = useState(false);
  const [validationSchema, setValidationSchema] = useState(
    getValidationSchema(fieldsToBeValidate, locale)
  );
  const [isSubmitting,setIsSubmitting]=useState(false);

  const formik = useFormik({
    initialValues: {
      email: location?.state?.email || "",
      password: "",
    },
    validationSchema,
    onSubmit(values) {setIsSubmitting(true)
      processData(values);
    },
  });

  useEffect(() => {
    getLocaleFromCookie();
    setValidationSchema(getValidationSchema(fieldsToBeValidate, locale));

    const timer = new IdleTimer({
      onTimeout: () => {
        if (publicRoutesName.indexOf(pathname) === -1) {
          logOutUser();
        }
      },
      onExpired: () => {
        //do something if expired on load
        if (publicRoutesName.indexOf(pathname) === -1) {
          logOutUser();
        }
      },
    });
    const expiredTime = parseInt(localStorage.getItem("_expiredTime"), 10);
    if (expiredTime > 0 && expiredTime < Date.now()) {
      timer.cleanUp();
    }

    return () => {
      if (publicRoutesName.indexOf(pathname) === -1) {
        timer.cleanUp();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** ON TIME OUT LOGOUT THE USER **/
  const logOutUser = async () => {
    await logOut();
  };

  /** SUBMIT LOGIn DETAILS **/
  const processData = async (dataToBeProcess) => {
    login({
      email: dataToBeProcess.email,
      password: dataToBeProcess.password,
    })
      .then((results) => {setIsSubmitting(false)
        formik.setSubmitting(false);
        if (process.env.REACT_APP_ENV === "local-online") {
          const authToken = results.data.token.plainTextToken;
          Cookies.set("AUTH-TOKEN", authToken);
          Session.storeSessionVar(
            "AUTH-TOKEN",
            results.data.token.plainTextToken
          );
          localStorage.setItem("AUTH-TOKEN", results.data.token.plainTextToken);
        }
        setUser(results.data);
        // setTeamId(results.data.team_id);
      })
      .catch((error) => {
        console.log(error);
        setIsSubmitting(false)
        formik.setSubmitting(false);
        if (error?.response?.data?.errors?.email) {
          formik.setErrors({
            ...formik.errors,
            email: error.response.data.errors.email[0],
          });
        } else {
          formik.errors.email = error?.response?.message || null;

          error?.response?.data &&
            formik.setErrors({
              ...formik.errors,
              email: error.response.data.message,
            });
        }
      });
  };

  // if (userData.isFetching) {
  //   return <RoundLoaderWithOverlay />;
  // }

  if (userData?.authenticated) {
    return <Navigate to={"/choose-company"} />;
  } else if (isSubmitting) {
    return (
      <div className={"main-content bg-light"}>
        <div className={"dashboard-sec"}>
          <Container fluid>
            <DashboardLoader />;
          </Container>
        </div>
      </div>
    );
  }

  /** RENDER HTML ***/
  return (
    <React.Fragment>
      {userData.isFetching && <RoundLoaderWithOverlay />}
      <div className="login-signup-form login-form-body">
        <div className="form-inner-main-bar">
          <div className="brand-logo-form">
            <a href={WEBSITE_URL}>
              <img src="https://app.saleoid.com/Saleoid-final.png" />
            </a>
            <a
              className="btn btn-lg btn-primary rounded-pill text-nowrap"
              href={
                WEBSITE_URL +
                "/checkout/monthly/9cb5e1b4-f99f-4677-9044-0c852c1bfacf"
              }
            >
              Schedule Demo
            </a>
          </div>
          <div className="form-field-bar">
            <div className="form-field-bar-inner login-form-wrap">
              <h2 className="mt-2 text-dark">
                LOGIN TO SALEOID
                {/* {locale("pages:signUp.Login to Account")} */}
              </h2>
              <p className="">
                Engage your customers. Build your brand. Do it all with Saleoid.
                {/* {locale(
                "pages:signUp.Engage your customers. Build your brand. Do it all with {{AppName}}",
                { AppName: "Saleoid" }
              )} */}
              </p>
              <div className="my-2">
                {location?.state?.email && location?.state?.cn && (
                  <p className="text-success">
                    You've successfully joined the{" "}
                    <b>{location?.state?.cn || ""}</b> client portal. Access
                    your account now by logging in with your credentials.
                  </p>
                )}
              </div>
              <Form onSubmit={formik.handleSubmit} autoComplete="off">
                <Form.Group className="form-group">
                  <Form.Label>
                    {locale("pages:signUp.Email Address")}
                  </Form.Label>
                  <Form.Control
                    className={
                      formik.touched.email && formik.errors.email
                        ? "is-invalid"
                        : ""
                    }
                    id="email"
                    name="email"
                    type="email"
                    placeholder="example@gmail.com"
                    onChange={formik.handleChange}
                    autoFocus
                    autoComplete="off"
                  />
                  <span className="field-icon">
                    <i className="ri-mail-line"></i>
                  </span>
                  <InLineErrorMessage
                    type="error"
                    name="email"
                    formik={formik}
                  />
                </Form.Group>
                <Form.Group className="form-group">
                  <Form.Label>{locale("pages:signUp.Password")}</Form.Label>
                  <Form.Control
                    className={
                      formik.touched.password && formik.errors.password
                        ? "is-invalid"
                        : ""
                    }
                    id="password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    placeholder="**********"
                    onChange={formik.handleChange}
                  />
                  <span
                    className="field-icon cursor-pointer"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <i
                      className={
                        "ri-eye-line " + (showPassword ? "text-primary" : "")
                      }
                    ></i>
                  </span>
                  <InLineErrorMessage
                    type="error"
                    name="password"
                    formik={formik}
                  />
                </Form.Group>
                <Nav className="forgot-password justify-content-end">
                  <Link
                    to="/forgot-password"
                    className={`nav-link p-0`}
                    role="button"
                  >
                    {locale("pages:signUp.Forgot Password")}
                  </Link>
                </Nav>
                <Button
                  variant="primary"
                  className="btn-primary btn-lg w-100 mt-4"
                  type="submit"
                >
                  {locale("pages:signUp.Sign In")}
                </Button>
                {/* <div className="or-divider text-uppercase my-3"><span>OR</span></div>
              <button className='btn btn-lg btn-outline-dark w-100 mb-4' type='button'>
                <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.1116 0.784688C7.22081 1.78753 4.7278 3.69095 2.99875 6.21538C1.2697 8.7398 0.395747 11.7522 0.505262 14.81C0.614778 17.8678 1.70199 20.81 3.6072 23.2042C5.51241 25.5985 8.1352 27.3187 11.0903 28.1122C13.4861 28.7304 15.9962 28.7575 18.4048 28.1913C20.5867 27.7012 22.604 26.6528 24.259 25.1489C25.9816 23.5358 27.2319 21.4837 27.8756 19.2132C28.5752 16.7442 28.6997 14.1476 28.2395 11.623H14.786V17.2038H22.5774C22.4216 18.0939 22.0879 18.9434 21.5963 19.7015C21.1046 20.4596 20.465 21.1108 19.7158 21.616C18.7644 22.2453 17.6919 22.6688 16.5671 22.8591C15.4391 23.0689 14.282 23.0689 13.154 22.8591C12.0107 22.6228 10.9292 22.1509 9.97824 21.4735C8.45059 20.3922 7.30353 18.8559 6.70075 17.084C6.08778 15.2789 6.08778 13.3219 6.70075 11.5168C7.12982 10.2515 7.83913 9.09942 8.77574 8.1466C9.84757 7.03621 11.2045 6.24249 12.6978 5.85253C14.191 5.46258 15.7628 5.49146 17.2407 5.93599C18.3952 6.2904 19.451 6.90961 20.3238 7.74426C21.2023 6.87027 22.0793 5.99401 22.9548 5.11549C23.4069 4.64308 23.8997 4.19327 24.3449 3.70956C23.0126 2.46971 21.4487 1.50496 19.7429 0.87058C16.6365 -0.257351 13.2376 -0.287663 10.1116 0.784688Z" fill="white"/>
                  <path d="M10.1105 0.783833C13.2362 -0.289246 16.6352 -0.259732 19.7418 0.867465C21.4479 1.50615 23.0111 2.47555 24.3416 3.72001C23.8895 4.20372 23.4126 4.65579 22.9515 5.12594C22.0745 6.00144 21.1982 6.87393 20.3227 7.74341C19.4499 6.90875 18.3941 6.28954 17.2396 5.93514C15.7622 5.48904 14.1905 5.4585 12.6968 5.84686C11.2032 6.23522 9.84539 7.02747 8.77239 8.13671C7.83578 9.08952 7.12647 10.2416 6.6974 11.5069L2.01172 7.87903C3.68891 4.55308 6.59285 2.00899 10.1105 0.783833Z" fill="#E33629"/>
                  <path d="M0.768557 11.4728C1.02041 10.2247 1.43853 9.01592 2.01174 7.87891L6.69742 11.5158C6.08445 13.3209 6.08445 15.2779 6.69742 17.083C5.13628 18.2885 3.57439 19.5001 2.01174 20.7176C0.576768 17.8613 0.139127 14.6068 0.768557 11.4728Z" fill="#F8BD00"/>
                  <path d="M14.7862 11.6191H28.2397C28.6999 14.1438 28.5754 16.7403 27.8758 19.2094C27.2321 21.4798 25.9818 23.5319 24.2592 25.145C22.7471 23.9651 21.2281 22.7942 19.716 21.6143C20.4657 21.1087 21.1055 20.4568 21.5973 19.6979C22.089 18.9389 22.4224 18.0885 22.5775 17.1977H14.7862C14.7839 15.3397 14.7862 13.4794 14.7862 11.6191Z" fill="#587DBD"/>
                  <path d="M2.00781 20.7186C3.57046 19.5131 5.13235 18.3016 6.69349 17.084C7.29747 18.8565 8.44617 20.3929 9.9755 21.4736C10.9294 22.1477 12.0133 22.6158 13.1581 22.8478C14.2861 23.0576 15.4431 23.0576 16.5712 22.8478C17.6959 22.6575 18.7684 22.234 19.7198 21.6047C21.232 22.7846 22.7509 23.9554 24.2631 25.1353C22.6083 26.6401 20.591 27.6892 18.4088 28.18C16.0002 28.7462 13.4901 28.7191 11.0944 28.1009C9.19953 27.5949 7.42963 26.7031 5.89559 25.4811C4.2719 24.192 2.94575 22.5675 2.00781 20.7186Z" fill="#319F43"/>
                </svg>
                Sign up with Google
              </button> */}
              </Form>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default SignIn;
